import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import ReportList from "../../../common/ReportList";
import Constants from "../../../../common/Constants";
// import moment from "moment";
// import { formatDateTime } from "../../../../common/Validations";
import PrintStatusReports from "./PrintStatusReports";
import ChemicalPopover from "../master/ChemicalPopover";
import {
  calculateDuration,
  currencyFormat,
  formatDateTime,
} from "../../../../common/Validations";
import ChemicalBatchViewJobcards from "./ChemicalBatchViewJobcards";

const BulkConsumpstionReports = () => {
  const { t } = useTranslation();
  const [displayFilter, setDisplayFilter] = useState(false);
  const [selectedRows, setSelectedRows] = useState(false);
  const [openViewJobcardCode, setOpenViewJobcardCode] = useState(false);

  const [chemicalBatchJobcardDataModel, setChemicalBatchJobcardDataModal] =
    useState(false);
  const [chemicalBatch, setChemicalBatch] = useState("");

  // Popover state: open, position, chemicals
  const [popover, setPopover] = useState({
    open: false,
    x: 0,
    y: 0,
    chemicals: [],
  });

  // Handle click on "Chemical List"
  const handleChemicalListClick = (event, row) => {
    event.stopPropagation();
    setPopover({
      open: true,
      x: event.clientX,
      y: event.clientY,
      chemicals: row.chemicals,
    });
  };

  // Close popover
  const handlePopoverClose = () => {
    setPopover((p) => ({ ...p, open: false }));
  };

  const handleChemicalBatchNo = async (chemicalBatchNo) => {
    setChemicalBatchJobcardDataModal(true);
    setChemicalBatch(chemicalBatchNo);
  };

  const columnsData = [
    {
      name: t("msg_common.status"),
      selector: (row) => row.status,
      sortable: true,
      cell: (row) => (
        <>
          {row.status === Constants.MASTER.STATUS.Active ? (
            <span className="bg-table-status bg-table-success-status">
              {t("msg_common.active")}
            </span>
          ) : row.status === Constants.MASTER.STATUS.Inactive ? (
            <span className="bg-table-status bg-table-danger-status">
              {t("msg_common.inactive")}
            </span>
          ) : (
            row.status
          )}
        </>
      ),
      width: "150px",
    },
    {
      name: "Batch No",
      selector: (row) => row.chemicalBatchNo,
      sortable: true,
      width: "160px",
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-new-status">
            {row.chemicalBatchNo}
          </span>
        </>
      ),
    },
    {
      name: "Jobcards",
      cell: (row) => (
        <div style={{ width: "100%", textAlign: "center" }}>
          <button
            className="btnTable"
            onClick={() => handleChemicalBatchNo(row.chemicalBatchNo)}
          >
            View Jobcards
          </button>
        </div>
      ),
      width: "150px",
    },
    {
      name: "Chemicals Value",
      width: "160px",
      cell: (row) => (
        <span
          style={{
            cursor: "pointer",
            color: "#1442b7",
            fontWeight: 600,
            display: "flex",
            alignItems: "center",
          }}
          onClick={(e) => handleChemicalListClick(e, row)}
        >
          <i className="bi bi-flask"></i> &nbsp; Chemical List
        </span>
      ),
      sortable: false,
    },
    {
      name: "Department",
      selector: (row) => row.deptName,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1 fw-bold ">
              {row?.deptName?.split(" - ")[0]}{" "}
              {row?.machineCode && (
                <span className="badge-amber">{row?.machineCode}</span>
              )}
            </p>
            <p className="m-0 p-0 ">{row?.deptName?.split(" - ")[1]} </p>
          </div>
        </>
      ),
    },
    {
      name: "Total OK / REJ Qty",
      selector: (row) => row.okCount,
      sortable: true,
      width: "240px",
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-success-status">
            {currencyFormat(row.okCount)}
          </span>
          <span className="bg-table-status bg-table-danger-status">
            {currencyFormat(row.rejectCount)}
          </span>
        </>
      ),
    },
    {
      name: "Total Qty",
      selector: (row) => row.totalCount,
      sortable: true,
      width: "160px",
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-text-status">
            {currencyFormat(row.totalCount)}
          </span>
        </>
      ),
    },
    {
      name: t("msg_master_list.msg_chemical.createdBy"),
      selector: (row) => row.loginUserId,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row.loginUserId} </p>
          <p className="m-0 p-0 ">{row.loginUserName} </p>
        </div>
      ),
    },
    {
      name: t("msg_common.created_date"),
      selector: (row) => row.dbDateTimeCreated,
      sortable: true,
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">
            {formatDateTime(row.dbDateTimeCreated)}
          </p>
        </div>
      ),
      width: "145px",
    },
    {
      name: "Closed By",
      selector: (row) => row.modifiedById,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row.modifiedById} </p>
          <p className="m-0 p-0 ">{row.modifiedByName} </p>
        </div>
      ),
    },
    {
      name: "Closed Date",
      selector: (row) => row.dbDateTimeUpdated,
      sortable: true,
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">
            {formatDateTime(row.dbDateTimeUpdated)}
          </p>
        </div>
      ),
      width: "145px",
    },
    {
      name: t("msg_reports.msg_machine_idle_status.duration"),
      selector: (row) => row.dbDateTimeCreated,
      sortable: true,
      width: "130px",
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-success-status">
            {calculateDuration(row.dbDateTimeCreated, row.dbDateTimeUpdated)}
          </span>
        </>
      ),
    },
  ];

  const handleSelectedRowsChange = ({ selectedRows }) => {
    setSelectedRows(selectedRows);
  };
  // eslint-disable-next-line no-unused-vars
  const handlePrintClick = () => {
    if (selectedRows) {
      setOpenViewJobcardCode(true);
    }
  };
  const resetJobcardModal = () => {
    setOpenViewJobcardCode(false);
  };

  const handleAckModelClose = () => {
    setChemicalBatchJobcardDataModal(false);
  };

  return (
    <main className="generatejobcard main" id="main">
      <Row className="justify-center subContent">
        <Col xs={8} md={8} className="rightSide">
          <div className="rightSideInner timesheet">
            <h2 className="mainTitle">{"Bulk Consumption Reports"}</h2>
            <p className="subText">
              {"Bulk Consumption Reports Detailed Page"}
            </p>
          </div>
        </Col>
        <Col xs={4} md={4} className="leftSide">
          <Button
            type="button"
            variant="primary"
            size="lg"
            className="btn btn-primary float-right searchFilter-btn"
            onClick={() => setDisplayFilter(!displayFilter)}
          >
            <i className="bi bi-filter"> </i>
          </Button>
        </Col>
        <hr />
      </Row>
      {/* <div className="jobcard-div">
        <Button variant="primary" onClick={handlePrintClick}>
          {"PRINT"}
        </Button>{" "}
        <span> </span>
      </div> */}
      <div>
        <ReportList
          selectableRows={false}
          columnsData={columnsData}
          displayProdStatusFilter={displayFilter}
          handleSelections={handleSelectedRowsChange}
          //rowsData={rowsData}
          resetFilerBox={setDisplayFilter}
          pageName={Constants.REPORTS.BULKCONSUMPTIONREPORTS.report}
          pageURL={Constants.REPORTS.BULKCONSUMPTIONREPORTS.list}
          name={Constants.REPORTS.BULKCONSUMPTIONREPORTS.name}
        />
      </div>

      {openViewJobcardCode && (
        <PrintStatusReports
          selectedItems={selectedRows}
          show={openViewJobcardCode}
          onHide={() => {
            resetJobcardModal();
          }}
        ></PrintStatusReports>
      )}

      <ChemicalPopover
        open={popover.open}
        x={popover.x}
        y={popover.y}
        chemicals={popover.chemicals}
        onClose={handlePopoverClose}
      />
      {chemicalBatchJobcardDataModel && (
        <ChemicalBatchViewJobcards
          show={chemicalBatchJobcardDataModel}
          onHide={handleAckModelClose}
          chemicalBatch={chemicalBatch}
        ></ChemicalBatchViewJobcards>
      )}
    </main>
  );
};

export default BulkConsumpstionReports;
